export default __webpack_public_path__ + "static/media/shop-gray.d04d7885.svg";